module.exports = new __parcel__URL__("Highlight2.389f4d9e.svg").toString();